<template>
  <div id="CaseApplyManage">
    <div v-if="CaseApplyManageShow" class="well" style="padding: 0 1em">
      <div style="text-align: left; padding: 0.5rem 2rem">
        <b-input-group class="mb-3">
          審核狀態過濾：
          <b-form-select
            class="form-control"
            id="IsCompleteSelectText"
            v-model="selected2"
            ref="selected2"

            :options="options2"
          >
          </b-form-select>
          申請項目過濾：
          <b-form-select
            class="form-control"
            id="ItemIDSelectText"
            v-model="selected"
            ref="selected"

            :options="options"
          >
          </b-form-select>
        </b-input-group>
        <b-input-group class="mb-3">
          學號search:
          <b-form-input v-model="sid" placeholder="學號"></b-form-input>

          查詢之前申請日期：
          <b-form-input
            v-model="ApplyTime"
            ref="ApplyTime"
            type="text"
            placeholder="YYYY-MM-DD"
            autocomplete="off"
          ></b-form-input>
          <b-input-group-append>
            <b-form-datepicker
              v-model="ApplyTime"
              button-only
              right
              locale="zh-tw"
              aria-controls="example-input"
              @context="onContext"
            ></b-form-datepicker>
          </b-input-group-append>
        </b-input-group>
        <div style="text-align: center; padding: 0.5rem 2rem">
          <button
            href="#"
            @click="getAllApply()"
            class="btn btn-outline-success"
            type="button"
            style="font-size: 14px; text-align: right"
          >
            送出查詢
          </button>
        </div>

        目前案件申請共 {{ total }}筆
      </div>

      <b-tabs content-class="mt-3" justified>
        <div
          class="dataTables_scrollBody"
          style="
            font-size: 14px;
            position: relative;
            overflow: auto;
            max-height: 100%;

            border-bottom: 1px solid #111;
            border-top: 1px solid #111;
          "
        >
          <b-table-simple
            class="ncut-table-menu-striped ncut-table-menu"
            fixed
            responsive
            bgcolor="#FFFFFF"
          >
            <b-thead class="ncut-thead-menu">
              <b-tr>
                <b-th style="width: 3em; min-width: 1em">申請案件編號</b-th>
                <b-th style="width: 6em; min-width: 1em">學號</b-th>
                <b-th style="width: 3em; min-width: 1em">學年</b-th>
                <b-th style="width: 2em; min-width: 1em">學期</b-th>
                <b-th style="min-width: 2em">申請項目</b-th>
                <b-th style="min-width: 2em">主辦單位</b-th>
                <b-th style="min-width: 5em">競賽分組</b-th>
                <b-th style="min-width: 5em">競賽種類名稱</b-th>
                <b-th style="min-width: 5em">組別</b-th>
                <b-th style="width: 2em; min-width: 1em">名次</b-th>
                <b-th style="min-width: 5em">申請日期</b-th>
                <b-th style="min-width: 2em">目前狀態</b-th>
                <b-th style="min-width: 2em">核准獎勵金</b-th>
                <b-th style="width: 100px; min-width: 10em">申請證明文件</b-th>
                <b-th style="width: 90px; min-width: 5em" colspan="2"
                  >管理</b-th
                >
              </b-tr>
            </b-thead>
            <b-tbody class="ncut-tbody-menu">
              <b-tr
                v-for="(i, index) in filteredDocs"
                :key="i.id"
                :index="i.id"
                :name="i.typeName"
                v-bind:style="{
                  background: selectedRowIndex == index ? headerColor : '',
                }"
                @click="selectedRowIndex = index"
              >
                <b-td style="text-align: left">
                  {{ i.id }}
                </b-td>
                <b-td style="text-align: left">
                  {{ i.sid }}
                </b-td>
                <b-td style="text-align: left">
                  {{ i.schyy }}
                </b-td>
                <b-td style="text-align: left">
                  {{ i.smt }}
                </b-td>
                <b-td style="text-align: left">
                  {{ getItem(i.item) }}
                </b-td>
                <b-td style="text-align: left">
                  {{ getUnit(i.unit) }}
                </b-td>
                <b-td style="text-align: left">
                  {{ getCGroup(i.cGroup) }}
                </b-td>
                <b-td style="text-align: left">
                  {{ i.typeName }}
                </b-td>
                <b-td style="text-align: left">
                  {{ getGroup(i.group) }}
                </b-td>
                <b-td style="text-align: left">
                  {{ i.ranking }}
                </b-td>
                <b-td style="text-align: left">
                  {{ getToday(i.applyTime) }}
                </b-td>
                <b-td style="text-align: left">
                  {{ getIsComplete(i.isComplete, i.reason) }}
                </b-td>
                <b-td style="text-align: left">
                  {{ i.money }}
                </b-td>
                <b-td style="text-align: left">
                  <span class="sel-file" v-if="i.rowId2 != null">
                    <a
                      :href="'./WebApi/Common/GetDocumentFile/' + i.rowId2"
                      target="_blank"
                    >
                      <img src="@/assets/images/disk.png" />秩序冊
                    </a> </span
                  ><br />

                  <span class="sel-file" v-if="i.rowId3 != null">
                    <a
                      :href="'./WebApi/Common/GetDocumentFile/' + i.rowId3"
                      target="_blank"
                    >
                      <img
                        src="@/assets/images/disk.png"
                      />得獎證明文件影印本 </a
                    ><br />
                  </span>
                  <span class="sel-file" v-if="i.rowId4 != null">
                    <a
                      :href="'./WebApi/Common/GetDocumentFile/' + i.rowId4"
                      target="_blank"
                    >
                      <img
                        src="@/assets/images/disk.png"
                      />競賽辦法及賽程時間內容資料 </a
                    ><br />
                  </span>
                </b-td>
                <b-td style="text-align: left">
                  <button
                    href="#"
                    @click="EditReview(i.id, i.sid)"
                    class="btn btn-outline-success"
                    type="button"
                    style="font-size: 14px"
                  >
                    審核
                  </button>
                </b-td>
                <b-td style="text-align: left">
                  <button
                    href="#"
                    @click="ListDetailPIData(i.sid)"
                    class="btn btn-outline-success"
                    type="button"
                    style="font-size: 14px"
                  >
                    獎金匯款資料
                  </button>
                </b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
          <b-pagination
            v-model="currentPage"
            :total-rows="total"
            :per-page="pageSize"
            v-if="total > pageSize"
          />
        </div>
      </b-tabs>
    </div>

    <b-modal size="xl" ref="EditReview" hide-footer>
      <template #modal-title> 審核結果 </template>
      <EditReview
        :id="id"
        :sid="sid"
        @hideModal="hideModal('EditReview')"
      ></EditReview>
    </b-modal>
    <b-modal size="xl" ref="PersonalInformation2" hide-footer>
      <template #modal-title> 申請者個人資料和匯款資訊檢視 </template>
      <PersonalInformation2
        :sid="editId"
        @hideModal="hideModal('PersonalInformation2')"
      ></PersonalInformation2>
    </b-modal>
  </div>
</template>


<script>
import EditReview from "@/components/EditReview.vue";
import PersonalInformation2 from "@/components/PersonalInformationView2.vue";
import * as tools from "../tool";
export default {
  name: "CaseApplyManage",
  data() {
    return {
      ApplyTime:null,
      id: 0,
      sid: null,
      courseName: null,
      CaseApplyManageShow: false,
      cid: null,
      signUpID: null,
      today: null,
      signUpStatus: null,
      selected: null,
      selected2: null,
      options: [
        { value: null, text: "請選擇" },
        { value: "99", text: "不分類" },
        { value: "0", text: "運動績優保送生" },
        { value: "1", text: "校內比賽" },
        { value: "2", text: "校外比賽" },
      ],
      options2: [
        { value: null, text: "請選擇" },
        { value: "0", text: "待審核" },
        { value: "1", text: "符合" },
        { value: "2", text: "不符合" },
        { value: "3", text: "資料錯誤" },
      ],
      ItemID: 99,
      IsComplete: 0,
      editId: 0,
      over: 0,
      total: 0,
      isIE: false,
      inputData: null,
      inputData2: null,
      selectedRowIndex: 0,
      currentPage: 1,
      currentPage2: 1,
      pageSize: 10,
      queryInfo: {
        Sid: null,
        ApplyTime2: null,
        Item: 99,
        IsComplete: 99,
      },
    };
  },
  components: {
    EditReview,
    PersonalInformation2,
  },
  methods: {
    hideModal(name) {
      this.$refs[name].hide();
      this.getApplyIsComplete();
    },
    getAllApply() {
      if(this.selected2 != null)
      this.IsComplete =this.selected2;

      this.queryInfo.Sid = this.sid;
      this.queryInfo.ApplyTime2 = this.ApplyTime;
      this.queryInfo.Item = this.ItemID;
      this.queryInfo.IsComplete = this.IsComplete;

      let vm = this;
      this.$http
        .put("./WebApi/EconomicDisadvantage/GetAllApply/", vm.queryInfo)
        .then((response) => {
          if (!tools.isNull(response)) {
            vm.inputData = response.data;
            vm.total = vm.inputData.length;
            vm.currentPage = 1;
            vm.currentPage2 = 1;
          }
        })
        .catch(function (error) {
          alert("網路連線失敗" + error);
          // tools.showAlert(vm.inputData, "danger", "網路連線失敗" + error);
        });
    },
    onContext(ctx) {
      this.ApplyTime = ctx.selectedYMD; //Selected: '2022-02-22'
    },

    getToday(updateTime) {
      var dd = new Date(updateTime);
      var today = dd.getDate().toString().padStart(2, "0"); //內建getDate 取到目前年月日
      var mm = (dd.getMonth() + 1).toString().padStart(2, "0"); //January is 0!
      var yyyy = dd.getFullYear();
      return tools.stringFormat("{0}-{1}-{2}", yyyy, mm, today);
    },
    getIsComplete(id, reason) {
      var ret;
      if (id == 0) ret = "待審查";
      else if (id == 1) ret = "符合";
      else if (id == 2) {
        ret = "不符合(" + reason + ")";
      }
      else if (id == 3) {
        ret = "資料錯誤(" + reason + ")";
      }

      return ret;
    },
    getItem(id) {
      var ret;
      if (id == 0) ret = "運動績優保送";
      else if (id == 1) ret = "校內比賽";
      else if (id == 2) ret = "校外比賽";
      return ret;
    },
    getUnit(id) {
      var ret;
      if (id == 0) ret = "體育室";
      else if (id == 1) ret = "中華民國大專院校體育總會(含聯賽)";
      else if (id == 2) ret = "其他";

      return ret;
    },
    getCGroup(id) {
      var ret;
      if (id == 0) ret = "公開組個人賽";
      else if (id == 1) ret = "一般組個人賽";
      else if (id == 2) ret = "公開組團體賽";
      else if (id == 3) ret = "一般組團體賽";

      return ret;
    },
    getGroup(id) {
      var ret;
      if (id == 0) ret = "男子組";
      else if (id == 1) ret = "女子組";
      else if (id == 2) ret = "混合組";

      return ret;
    },
     getApplyIsComplete() {
      let vm = this;
      vm.selected2=vm.IsComplete ;

      this.$http
        .get(
          "./WebApi/EconomicDisadvantage/GetApplyIsComplete/".concat(vm.IsComplete)
        )
        .then((response) => {
          if (!tools.isNull(response)) {
            vm.inputData = response.data;
            vm.total = vm.inputData.length;
            vm.currentPage = 1;
            vm.currentPage2 = 1;
          }
        })
        .catch(function (error) {
          alert("網路連線失敗" + error);
          // tools.showAlert(vm.inputData, "danger", "網路連線失敗" + error);
        });
    },

    EditReview(id, sid) {
      var vm = this;
      vm.id = id;
      vm.sid = sid;
      vm.$refs["EditReview"].show();
    },

    ListDetailPIData(id) {
      var vm = this;
      vm.editId = id;
      vm.$refs["PersonalInformation2"].show();
    },
  },
  computed: {
    filteredDocs: function () {
      let data = [];
      if (this.inputData != null) {
        data = this.inputData.slice(
          (this.currentPage - 1) * this.pageSize,
          this.currentPage * this.pageSize
        );
      }
      return data;
    },

    headerColor() {
      return "#f7e8aa";
    },
  },
  created() {
    console.log("======created CaseApplyManageView =====");
    this.isIE =
      navigator.userAgent.indexOf("MSIE ") > -1 ||
      navigator.userAgent.indexOf("Trident/") > -1 ||
      navigator.userAgent.indexOf("Edge") > -1;
    let vm = this;

    vm.CaseApplyManageShow = true;

    vm.getApplyIsComplete();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
